import {FC} from "react";
import {useTranslation} from "react-i18next";
import {ArrowUturnLeftIcon} from "@interstate/components/Icons";
import {Button} from "@interstate/components/Button";
import {useNavigation} from "../../../../../navigation";
import {EntitySourceType} from "../../../../EntitySourceType";
import {usePlan} from "../../context";

export const SuccessControls: FC = () => {
  const {t} = useTranslation();
  const {plan} = usePlan();
  const {navigateToEntityFromEvent} = useNavigation();

  return (
    <div data-testid="stepper-controls" className="stepper-controls">
      <div
        data-testid="stepper-controls-left"
        className="stepper-controls-left"
      />
      <div
        data-testid="stepper-controls-right"
        className="stepper-controls-right">
        <Button
          data-testid="back-to-client-button"
          buttonStyle="tertiary"
          startIcon={<ArrowUturnLeftIcon />}
          onClick={event =>
            navigateToEntityFromEvent(
              event,
              plan.source.caId,
              EntitySourceType.CLIENT_HIERARCHY
            )
          }>
          {t("create-organization.back-to-client-entity")}
        </Button>
      </div>
    </div>
  );
};
